// extracted by mini-css-extract-plugin
export default {"crossSiteLabel":"iZ-z","vrsnlCrossSiteLabel":"jZ-z"};